import * as React from "react";
const baseCls = "rj-yourbet__btn";
export class Button extends React.Component {
    render() {
        const mdfr = this.props.modifier ? ` ${baseCls}--${this.props.modifier}` : "";
        const dataUat = this.props.modifier ? `-${this.props.modifier}` : "";
        return (React.createElement("button", { className: `${baseCls}${mdfr}`, "data-uat": `your-bet-btn${dataUat}`, onClick: this.props.handler, disabled: this.props.disabled },
            React.createElement("span", { className: `${baseCls}-inner`, "data-uat": "your-bet-btn-name" }, this.props.children)));
    }
}
//# sourceMappingURL=Button.js.map